import CircularProgressWithContent from "@components/CircularProgressWithContent/CircularProgressWithContent";
import { Status } from "@api/apiClient";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import SaveIcon from "@mui/icons-material/Save";
import { Box } from "@mui/material";
import { observer } from "mobx-react";

// ProgressType enum (matches backend)
export enum ProgressType {
  Extract = "Extract",
  Import = "Import"
}

export interface JobProgressIndicatorProps {
  progress?: number;
  progressType?: string;
  status?: Status;
  size?: number;
}

const JobProgressIndicator = observer((props: JobProgressIndicatorProps) => {
  const { progress, progressType, status, size = 32 } = props;

  // Check if job is in progress
  const isInProgress = progress !== undefined || status === Status.Inprogress || status === Status.Pending;

  if (!isInProgress) {
    return null;
  }

  // Show indeterminate spinner during startup (undefined or 0%), determinate once progress > 0
  const hasRealProgress = (progress ?? 0) > 0;
  const progressValue = hasRealProgress ? progress : undefined;

  // Select icon based on progress type and phase:
  // - No progress yet: UploadIcon (uploading/starting)
  // - Extract type: DownloadIcon (extracting from model)
  // - Import type: SaveIcon (saving to database)
  let icon = <UploadIcon fontSize="small"/>;
  if (hasRealProgress) {
    if (progressType === ProgressType.Import) {
      icon = <SaveIcon fontSize="small"/>;
    } else {
      icon = <DownloadIcon fontSize="small"/>;
    }
  }

  return (
    <Box sx={{ position: "relative", display: "inline-flex", alignItems: "center", height: "100%" }}>
      <CircularProgressWithContent content={icon} size={size} value={progressValue} />
    </Box>
  );
});

export default JobProgressIndicator;

